export const isMobile = () => {
  return window.innerWidth <= 991;
};

export default {
  isMobile: isMobile()
};
